<!--
 * @Date: 2023-10-24 10:54:38
 * @LastEditors: asahi
 * @LastEditTime: 2023-11-09 09:49:38
 * @FilePath: \dataview-next\src\custom-component\UEClient\UEClient.vue
-->
<!--
 * @Date: 2022-08-22 11:28:17
 * @LastEditors: asahi
 * @LastEditTime: 2023-11-08 17:30:27
 * @FilePath: \dataview-next\src\custom-component\UEClient\UEClient.vue
-->
<template>
    <article >
    </article>
</template>
<script>
    import { UEClient }  from './UEClient';
    import { mapState } from 'vuex';
    import CustomComponentMixin from '@/custom-component/mixins/CustomComponentMixin.js';
    import BehaviorHandlerMixin from '@/custom-component/mixins/BehaviorHandlerMixin.js';
    import eventBus from '@/plugins/eventBus';
    
    let client = null;
    export default {
        data () {
            return {
                
            }
        },
        mixins : [CustomComponentMixin , BehaviorHandlerMixin],
        computed: {
            ...mapState(['componentData', '_PageCustomStatus', '_APPCustomStatus']),
        },
        methods : {
            /**
             * 初始化UE事件
             */
            init(){
                client = new UEClient();

                this.addResolveList('InformationID' , '摄像头编码');
                this.addResolveList('deviceID','楼栋类型');
                this.addResolveList('EquipmentData','选中设备数据');

                this.addResolveList('SystemIndex','系统编号');
                this.addResolveList('BuildIndex','建筑编号');
                this.addResolveList('FloorIndex','楼层编号');

                this.registerActionConfig('Equipment' , '设备消息');

                this.addResolveList('ContrlStateData','状态控制数据'); 
                this.registerActionConfig('ContrlState' , '状态控制');


                this.emitUEEvent({
                    id : "ClientInined"
                });
                // 方便实施配置取值，后续在此添加
                this.element.metadata = {
                    System: 'System',
                    Build: 'Build',
                    Floor: 'Floor'
                };
            },  
            initEventListener(){
                this.element.behaviors = [];
                //注册行为接受外部传入
                this.registerBehaviors([{
                    label : "触发UE事件",
                    desc : `
                    `,
                    value : "emitUEEvent",
                    func : ( params )=>{
                        console.log(params);

                        let data = {};

                        if( params.value && !params.data){
                            data = { value : params.value};
                        }

                        if(params.json ){
                            data = Object.assign(data, JSON.parse(params.json));
                        }

                        params.data = JSON.stringify(data);
                        this.emitUEEvent(params);
                    },
                }]);

                client.on('onUEAction',( res )=>{
                    console.log(res);

                    switch(res.type){
                        case "OnSceneInited":
                            this.onSceneInited(res.data );
                            break;
                        case "Equipment":
                            this.setResolveData('EquipmentData' , res.data);

                            this.setResolveData('InformationID',res.data['Information ID']);
                            this.setResolveData('deviceID' , res.data['device ID']);
                            
                            this.setResolveData('SystemIndex' , res.data['SystemIndex']);
                            this.setResolveData('BuildIndex' , res.data['BuildIndex']);
                            this.setResolveData('FloorIndex' , res.data['FloorIndex']);

                            this.onAction('Equipment');
                            break;
                        // case "ContrlState":
                        //     this.setResolveData('ContrlStateData', res.data);
                        //     this.onAction('ContrlState');
                        //     break;
                    }
                    
                });

                client.on('ContrlState', (res)=>{
                    this.setResolveData('ContrlStateData', res.data);
                    this.onAction('ContrlState'); 
                    console.log('触发UE行为' , res);

                    // 此处不需要进行重新赋值，实际是进行命名操作，已移动至init方法
                    // if(!this.element) this.element.metadata = {}

                    if(res.data){
                        for(let id in res.data){
                            this.setResolveData(id, res.data[id]);
                        }
                    }else{
                        for(let id in res){
                            this.setResolveData(id, res[id]);
                        }
                    }

                });
            },
            /**
             * UE场景初始完成
             */
            onSceneInited( config = {}){
                if(config.ActionConfig){
                    for(let { id , label } of config.ActionConfig){
                        this.registerActionConfig(id , label);
                    }
                }
            },
            /**
             * 触发UE事件
             * @param {*} params 
             */
            emitUEEvent( params ){
                if( !params.data ) params.data = "{}";
                client.sendMsg(params.id  , params.data );
            },
            //注册组件内事件
            registerActionConfig( id , label ){
                const element = this.element;

                if(!element.actionConfig){
                    element.actionConfig = {}
                }

                if(!element.actionConfig[id]){
                    element.actionConfig[id] = {
                        use: true,
                        useDepend: false,
                        dependLogic: [],
                        type: id,
                        name: label,
                        color: '#409EFF',
                        btnType: 'text',
                        btnSize: '',
                        margin: 5,
                        // eventList: [],
                        // permission: [], // 权限
                        // archiLimit: [], // 架构限制
                    }
                }
            },
            /**
             * 删除组件内事件
             * @param {} id
             */
            removeActionConfig(id){
                const element = this.element;

                if(!element.actionConfig){
                    element.actionConfig = {}
                }

                if(element.actionConfig[id]){
                    delete element.actionConfig[id]
                }
            },
            //触发行为
            onAction( id ){
                const ac = this.element.actionConfig;
                if(!ac[id]) return;

                const eventList = ac[id].eventList || [];

                for(let el of eventList){
                    const { pattern, eventList = [], specialEventList = []  } = el;
                    const resultList = pattern === 'special' ? specialEventList : eventList;

                    for(let ele of resultList){
                        const { effects , behaviors } = ele;
                        effects.forEach((effect) => {
                            this.$store.commit('triggerEvents', {
                                config: {
                                    ...ele,
                                ...effect
                                },
                                element: this.element,
                                EDITOR_pageUUID: this.EDITOR_pageUUID
                            });
                        });

                        behaviors.forEach(behavior => {
                            this.$store.commit('triggerEvents', {
                                config: {
                                    behavior,
                                    isBehavior: true
                                },
                                element: this.element,
                                EDITOR_pageUUID: this.EDITOR_pageUUID
                            });
                        });
                    }
                }

            },
            //设置组件暴露数据
            setResolveData( id , data){
                // 原代码
                // this.element.resolveData[id] = data;
                // 2023-09-28 修改内容
                // 拷贝resolevData
                const resolveData = {
                    ...this.element.resolveData,
                    [id]: data
                }
                this.element.resolveData = resolveData;
                // 修改store 中的内容 主要修改store
                this.$store.commit('modifyComponent', {
                    component: {
                        ...this.element,
                        resolveData: resolveData
                    },
                    containerId: null,
                    isModify: true,
                    pageUUID: this.EDITOR_pageUUID
                });
                // 触发 EventBug 请求数据 相关事件
                // TIPS 合适触发合适的问题
                eventBus.$emit('databaseTrigger', {
                    componentId: this.element.id,
                    action: 'any',
                    output: resolveData
                });
                // 2023-09-28 修改内容结束
            },
            //添加到组件暴露数据的列表
            addResolveList( uuid , name){
                this.element.UEResolveList.push({
                    uuid,
                    name,
                });
            },
        },
        mounted (){
            this.element.resolveData = {};
            this.element.UEResolveList = []
            this.init();
            this.initEventListener();

            console.log('UE事件中心注册完毕---------------------------------------------')
        },
    }
</script>
<style scoped>
    .bimviewer_main{
        height: 100%;
        width: 100%;
    }
    .mask{
        height: 100%;
        width: 100%;
        position: absolute;
        z-index: 999;
    }
</style>
